import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from "react";
import { injectIntl } from "react-intl";
import { ErrorBoundary, SearchBox } from "@elastic/react-search-ui";
import { Autocomplete } from "@elastic/react-search-ui-views";
import { ReactComponent as SearchIcon } from "../../assets/icons/magnifying-glass.svg";
import { normalizeSearchTerm, resolveQueryString } from "../../utils/functions";
import "./searchfield.css";
export const SearchFieldAutocomplete = ({ getMenuProps, setHighlightedIndex, ...props }) => (_jsx(Autocomplete, { ...props, getMenuProps: (menuProps) => getMenuProps({
        ...menuProps,
        onMouseLeave: (event) => {
            menuProps.onMouseLeave?.(event);
            setHighlightedIndex(null);
        },
    }) }));
/**
 * The custom input component that includes our search icon.
 * @param getAutocomplete used to determine where the autocomplete dropdown will be shown.
 * @param getInputProps returns the input props
 * @param getButtonProps returns the button props
 */
export const SearchFieldInput = ({ getAutocomplete, getInputProps, getButtonProps, }) => {
    const [disabled, setDisabled] = useState(false);
    function customOnInput(e) {
        setDisabled(e.currentTarget.value === "");
        return e.currentTarget.value;
    }
    return (_jsxs(Fragment, { children: [_jsxs("div", { className: "sui-search-box__wrapper", children: [_jsx("input", { ...getInputProps(), "data-testid": "customSearchField", onInput: customOnInput }), getAutocomplete()] }), _jsx("button", { tabIndex: 0, ...getButtonProps({
                    disabled: disabled,
                    className: "search-button",
                }), "data-testid": "searchButton", children: _jsx(SearchIcon, {}) })] }));
};
/**
 * Search field component, used by itself as an exported component.
 * On search event, redirects the user to a /search page with selected filters
 */
export const SearchField = injectIntl(({ intl, filters, placeholder }) => {
    function navigate(url) {
        const lang = `/${intl.locale}`;
        const urlWithLang = intl.locale === "en" ? url : lang + url;
        location.assign(urlWithLang);
    }
    return (_jsx("div", { className: "trimble-search", id: "searchField", "data-testid": "search-field", children: _jsx(ErrorBoundary, { children: _jsx(Fragment, { children: _jsx("div", { className: "search-field", children: _jsx(SearchBox, { onSubmit: (searchTerm) => {
                            if (searchTerm) {
                                navigate("/search?q=" + encodeURIComponent(normalizeSearchTerm(searchTerm)) + resolveQueryString(filters));
                            }
                        }, onSelectAutocomplete: (selection, _options, defaultOnSelectAutocomplete) => {
                            if (selection.suggestion) {
                                navigate("/search?q=" + encodeURIComponent(selection.suggestion));
                            }
                            else {
                                defaultOnSelectAutocomplete(selection);
                            }
                        }, autocompleteMinimumCharacters: 3, autocompleteResults: {
                            linkTarget: "_blank",
                            titleField: "title",
                            urlField: "url",
                            shouldTrackClickThrough: true,
                            clickThroughTags: ["autocomplete"],
                        }, autocompleteSuggestions: true, searchAsYouType: false, shouldClearFilters: false, autocompleteView: SearchFieldAutocomplete, inputView: SearchFieldInput, inputProps: {
                            placeholder: placeholder || intl.formatMessage({ id: "searchPlaceholder" }),
                        } }) }) }) }) }));
});
